import { http, id } from 'utils'
import { SET_ITEMS } from 'vx/mutations'

export default {
  namespaced: true,

  state: {
    divisions: []
  },

  actions: {
    async getDivisions ({ commit, state }, { invoiceRunId, params = {} } = {}) {
      const response = await http.get(`invoice-runs/${id(invoiceRunId)}/divisions`, { params })

      commit(SET_ITEMS, response.data.data)

      return response
    },

    resetDivisions ({ commit }) {
      commit(SET_ITEMS, [])
    }
  },

  mutations: {
    [SET_ITEMS] (state, items) {
      state.divisions = items
    }
  }
}
